import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ClienteService } from '../api/cliente-service.service';
import { UsuarioService } from '../api/usuario.service';
import { ModalController, ToastController, IonicModule } from '@ionic/angular';
import { Subject } from 'rxjs';
import { NgIf, NgFor } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import QuillTableBetter from 'quill-table-better';

@Component({
  selector: 'app-meus-clientes-edicao',
  templateUrl: './meus-clientes-edicao.page.html',
  styleUrls: ['./meus-clientes-edicao.page.scss'],
  imports: [
    NgIf,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    QuillModule,
  ],
})
export class MeusClientesEdicaoPage implements OnInit {
  @Input()
  objEdicao: any;
  ionicForm: any = {};
  @Input()
  subject: Subject<any> = new Subject<any>();
  toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{ 'header': 1 }, { 'header': 2 }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }],
    [{ 'direction': 'rtl' }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['clean'],
    ['link', 'image', 'video'],
    ['table-better']
  ];
  quillConfig = {
    toolbar: {
      container: this.toolbarOptions,
    },
    'table-better': {
      language: 'pt_BR',
      // Optional: customize the sub-menus for table operations
      menus: ['column', 'row', 'merge', 'table', 'cell', 'wrap', 'delete'],
      toolbarTable: true, // Show the table toolbar when a table is selected
    },
    keyboard: {
      // Optional: include keyboard bindings for table actions
      bindings: QuillTableBetter.keyboardBindings,
    },
    // ensure the default 'table' module is disabled if using a third-party one
    // table: false,
  };
  constructor(
    public formBuilder: FormBuilder,
    private toastController: ToastController,
    private modalController: ModalController,
    private clienteService: ClienteService,
    private usuarioService: UsuarioService,
  ) {}
  ngOnInit() {
    Quill.register(
      {
        'modules/table-better': QuillTableBetter,
      },
      true,
    );
    this.ionicForm = this.formBuilder.group({
      nome: [
        this.objEdicao?.Nome,
        [Validators.required, Validators.minLength(3)],
      ],
    });
  }
  blur(event) {
    if (!this.objEdicao) this.objEdicao = {};
    this.objEdicao.Anotacoes = event.editor.root.innerHTML;
  }
  created(event: any) {
    event.root.innerHTML = this.objEdicao?.Anotacoes || '';
  }
  salvar() {
    if (this.ionicForm.valid) {
      this.usuarioService
        .obterPlano(this.usuarioService.get().Id)
        .then((data: any) => {
          var model = {
            Id: undefined,
            Nome: this.ionicForm.controls['nome'].value,
            Anotacoes: this.objEdicao?.Anotacoes || '',
            IdPlano: data.Id,
            IdUsuario: this.usuarioService.get().Id,
            IdUsuarioAlteracao: this.usuarioService.get().Id,
          };
          var funcao;
          if (this.objEdicao?.Id) {
            model.Id = this.objEdicao.Id;
            funcao = this.clienteService.alterar(model);
          } else funcao = this.clienteService.inserir(model);
          funcao.then((data) => {
            this.presentToast('🎉 Cliente salvo com sucesso!');
            this.fechar();
            this.subject.next('');
          });
        });
    }
  }
  async presentToast(text: string) {
    const toast = await this.toastController.create({
      message: '',
      duration: 10000,
      position: 'top',
      color: 'success',
      cssClass: '',
      buttons: [
        {
          side: 'start',
          icon: 'checkmark-done-outline',
          text: ' ' + text,
        },
      ],
    });
    toast.onDidDismiss().then((e) => {});
    toast.present();
  }
  deletarMembroPlano(membro: any) {}
  fechar() {
    this.modalController.dismiss({});
  }
}
